import { useTranslation } from 'react-i18next';
import { Button } from 'ccs-ui-components';
import classes from './EventSchema.module.scss';
import { EventSchemaDetail } from '../../../store/_api/TypeDefs';
import EventSchema from '../../event-schema/EventSchema';
import { EVENT_ROUTE } from '../../../../control-plane/constants';

interface EventSchemaSidebarProps {
  onClose: () => void;
  eventSchema?: EventSchemaDetail;
}

const EventSchemaSidebar = ({ onClose, eventSchema = undefined }: EventSchemaSidebarProps) => {
  const { t: translate } = useTranslation();

  const eventTitle =
    eventSchema &&
    `${eventSchema.eventName} (${translate('journey_builder_component.txt_version', { version: eventSchema.version })})`;

  const getEventUrl = () => {
    if (eventSchema) {
      return `${EVENT_ROUTE.EVENTS_VIEW_ROUTE}${eventSchema.eventName}/${eventSchema.version}`;
    }
    return '';
  };

  return (
    <>
      <div className={classes['sidebar-heading']} data-testid="eventSchemaSideBarHeader">
        <div className={classes['close-sidebar']}>
          <div className={classes['sidebar-title']} data-testid="sidebarTitle">
            {eventSchema && (
              <a
                href={getEventUrl()}
                target="_blank"
                rel="noopener noreferrer"
                className={classes['event-link']}
                data-testid="eventSchemaViewLink"
                title={`View ${eventTitle} details in new tab`}
              >
                {eventTitle}
                <i className="fa-solid fa-arrow-up-right-from-square" />
              </a>
            )}
            {!eventSchema && <span>Event Schema</span>}
          </div>
          <Button variant="tertiary" data-testid="sidebarCloseBtn" onClick={onClose}>
            <i className="fa-solid fa-xmark" />
          </Button>
        </div>
      </div>
      <EventSchema eventSchema={eventSchema} />
    </>
  );
};

export default EventSchemaSidebar;
